
export const dataCategory = [
    { value: "E-com", key: "ECOMMERCE" },
    { value: "Convience store", key: "CONVENIENCE_STORE" },
    { value: "Nhà hàng", key: "RESTAURANT" },
    { value: "Cafe", key: "CAFE" },
    { value: "Micro merchant", key: "MICRO" },
    { value: "Giải trí", key: "ENTERTAINMENT" },
];